import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
 * Encoding forms with attachments (input type file)
 */


function encodeWithFile(data) {
  var formData = new FormData();
  Object.entries(data).forEach(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    formData.append(key, value);
  });
  return formData;
}
/*
 * Encoding forms without attachments
 */


function encodeWithoutFile(data) {
  return Object.entries(data).map(function (_ref2) {
    var key = _ref2[0],
        value = _ref2[1];
    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).join('&');
}

function isFormDataWithFile(data) {
  return Object.values(data).some(function (value) {
    return value instanceof File;
  });
}
/*
 * AJAX Netlify Forms submission
 */


function submitFormToNetlify(data) {
  return fetch('/', _extends({
    method: 'POST'
  }, !isFormDataWithFile(data) && {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }, {
    body: isFormDataWithFile(data) ? encodeWithFile(data) : encodeWithoutFile(data)
  }));
}

export { submitFormToNetlify };